function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "nw2JPvgEzDKQpjWgMaZM5a",
  cx: 48.477,
  cy: 36.475,
  r: 22.942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#bd8af5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.137,
  stopColor: "#b88bf5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.309,
  stopColor: "#a88ff3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.499,
  stopColor: "#8f96f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.702,
  stopColor: "#6b9eef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.913,
  stopColor: "#3eaaec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29afea"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#nw2JPvgEzDKQpjWgMaZM5a)",
  d: "M40,6H8C6.895,6,6,6.895,6,8v32c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V8C42,6.895,41.105,6,40,6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#436dcd",
  d: "M32.065,23.065c-1.149-1.149-3.005-1.174-4.185-0.057L18,32.368V42h22c1.105,0,2-0.895,2-2v-7L32.065,23.065z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.5,
  cy: 14.5,
  r: 3.5,
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "nw2JPvgEzDKQpjWgMaZM5b",
  x1: 23.91,
  x2: 23.91,
  y1: 18.133,
  y2: 42.415,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#124787"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.923,
  stopColor: "#173b75"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#173a73"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#nw2JPvgEzDKQpjWgMaZM5b)",
  d: "M8,42h32c0.811,0,1.507-0.485,1.82-1.18L20.065,19.065c-1.149-1.149-3.005-1.174-4.185-0.057L6,28.368V40C6,41.105,6.895,42,8,42z"
});

function SvgPhotos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.89b5bcec.svg";
export { ForwardRef as ReactComponent };